export const USE_HEALTH_INSURANCE_QUERY_KEY = 'healthInsurance';
export const HEALTH_INSURANCE_API_URL = 'data/healthInsurances';
